import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Form, Field } from 'react-final-form'
import { createPersistDecorator } from 'final-form-persist'
import ReCAPTCHA from 'react-google-recaptcha'
import { loadStripe } from '@stripe/stripe-js'
import { Button } from '@turretcss/react'

import { titleOptions } from './constants/titleOptions'
import { postJson } from './utils/apiUtils'
import { ErrorField } from './components/ErrorField'
import { TextField } from './components/TextField'
import { SelectField } from './components/SelectField'
import { SubmitButton } from './components/SubmitButton'

function getOnSubmit(stripePromise) {
  return function(values) {
    return postJson('/api/donations/submit.json', values)
      .then(({ session_id }) => stripePromise.then(stripe => stripe.redirectToCheckout({ sessionId: session_id })))
      .then(({ error }) => {
        if (error) throw error
      })
      .catch(err => err.errors || { FORM_ERROR: err })
  }
}

const { persistDecorator } = createPersistDecorator({
  name: 'DonationForm',
  debounceTime: 500,
  storage: sessionStorage,
})

function getFullName(data) {
  return [data.title, data.first_name, data.last_name].filter(Boolean).join(' ')
}

const DonationForm = props => {
  const [stripePromise] = useState(() => loadStripe(props.stripe_key))
  return (
    <Form
      decorators={[persistDecorator]}
      onSubmit={getOnSubmit(stripePromise)}
      initialValues={{
        amount: '0',
        country: 'AUSTRALIA',
      }}
      render={formState => (
        <form onSubmit={formState.handleSubmit}>
          <div className="background-pink-10 padding-vertical-xl">
            <div className="container">
              <div className="max-width-m margin-auto">
                <h3 className="display-title display-title-l color-pink-90 margin-bottom-l">Select an amount</h3>
                <Field name="amount">
                  {({ input: { value, onChange } }) => {
                    const numericValue = parseFloat(value, 10) || 0
                    return (
                      <div className="flex flex-wrap justify-content-flex-start margin-negative-xxs">
                        <Button
                          size="l"
                          color={numericValue === 5000 ? 'primary' : 'white'}
                          className="margin-xxs search-button quiz"
                          onClick={() => onChange('5000')}>
                          $5,000
                        </Button>
                        <Button
                          size="l"
                          color={numericValue === 1500 ? 'primary' : 'white'}
                          className="margin-xxs search-button quiz"
                          onClick={() => onChange('1500')}>
                          $1,500
                        </Button>
                        <Button
                          size="l"
                          color={numericValue === 500 ? 'primary' : 'white'}
                          className="margin-xxs search-button quiz"
                          onClick={() => onChange('500')}>
                          $500
                        </Button>
                        <Button
                          size="l"
                          color={numericValue === 100 ? 'primary' : 'white'}
                          className="margin-xxs search-button quiz"
                          onClick={() => onChange('100')}>
                          $100
                        </Button>
                      </div>
                    )
                  }}
                </Field>
              </div>
            </div>
            <div className="container margin-top-l">
              <div className="max-width-m margin-auto">
                <label htmlFor="amount">Or enter your own</label>
                <div className="input-group align-items-center">
                  <span className="font-size-l margin-right-xxs font-weight-bold">$</span>
                  <Field
                    name="amount"
                    component="input"
                    type="number"
                    id="amount"
                    className="input-xl input-primary-100"
                  />
                </div>
                <ErrorField name="amount" />
              </div>
            </div>
          </div>

          <div className="container padding-vertical-xl">
            <div className="max-width-m margin-auto">
              <h3 className="display-title display-title-l margin-bottom-m">Details for your tax receipt</h3>

              <SelectField name="title" label="Title" options={titleOptions} required />
              <TextField name="first_name" label="First Name" required />
              <TextField name="last_name" label="Last Name" required />
              <TextField name="email" label="Email" type="email" required />
              <TextField name="phone" label="Phone" type="tel" required />

              <hr />

              <TextField
                name="acknowledgement"
                label="Donation acknowledgement"
                // placeholder={getFullName(formState.values)}
                autoComplete="off"
                required
              />

              <Field name="recaptcha_token">
                {field => <ReCAPTCHA sitekey={props.reCAPTCHA_sitekey} onChange={field.input.onChange} />}
              </Field>
              <ErrorField name="recaptcha_token" />

              <SubmitButton formState={formState} className="button button-pink button-icon-arrow margin-top-l">
                Give Now
              </SubmitButton>
            </div>
          </div>
        </form>
      )}
    />
  )
}

window.DonationForm = {
  init: (id, props) => {
    ReactDOM.render(<DonationForm {...props} />, document.getElementById(id))
  },
}
